export default "__VITE_ASSET__CyiMIl0O__"